// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"e6d3e46d","78":"269dc19f","137":"7264125a","208":"a73d33e5","322":"ded6003e","453":"bb96fcf6","693":"dda3f6d1","849":"3eb7f46b","937":"489ffa11","952":"cc8d8b3a"}[chunkId] + ".chunk.js";
};